import { createSelector } from 'reselect';
import { flow } from 'fp-ts/function';
import { createAsyncMetaSelectors } from '@mews/framework';
import { localizeWallClockDateString } from '@mews-commander/utils';
import { getCustomer } from '@mews-commander/legacy-entities/src/ducks';
import { moduleSelector } from './module';

const getStateInit = flow(moduleSelector, (state) => state.init);
const getStateUpdate = flow(moduleSelector, (state) => state.update);

const getInitMeta = flow(getStateInit, (init) => init.meta);
const getUpdateMeta = flow(getStateUpdate, (update) => update.meta);

export const [isUpdating, hasUpdateFailed] = createAsyncMetaSelectors(getUpdateMeta);
export const [isFetching, hasFetchFailed] = createAsyncMetaSelectors(getInitMeta);

export const getProfileFormInitialValues = createSelector(getCustomer, (customer) => ({
    email: customer?.email ?? null,
    titlePrefix: customer?.title ?? null,
    firstName: customer?.firstName ?? null,
    lastName: customer?.lastName ?? '',
    secondLastName: customer?.secondLastName ?? null,
    gender: customer?.customerSex ?? null,
    nationality: customer?.nationalityCode ?? null,
    telephone: customer?.telephone ?? null,
    birthDate: customer?.birthDate ? localizeWallClockDateString(customer.birthDate) ?? null : null,
    birthPlace: customer?.birthPlace ?? null,
    language: customer?.preferredLanguageCode ?? null,
    carRegistrationNumber: customer?.carRegistrationNumber ?? null,
    taxIdentifier: customer?.taxIdentifier ?? null,
    companyFieldId: customer?.companyId ?? null,
    occupation: customer?.occupation ?? null,
    withdrawCardConsent: customer?.withdrawCardConsent ?? false,
    cardConsentEnabled: customer?.cardConsentEnabled ?? false,
}));

export const isCardConsentEnabled = flow(getProfileFormInitialValues, (values) => values.cardConsentEnabled);
